<template>
  <div>
    <van-skeleton title animate :row="12" :round="true" :loading="loading_ske">
      <div class="titles">
        <div class="dev02">
          设备列表
          <Icon type="md-add-circle" class="add01" @click="onModel1"/>
        </div>
        <div class="dev03">
          <Button class="dev01 dev04" type="primary" shape="circle" icon="md-attach" @click="toGzDc">设备故障单导出</Button>
          <Button class="dev01 dev04" type="primary" shape="circle" icon="md-attach" @click="exportDc">维修单导出</Button>
          <Button class="dev01" type="primary" shape="circle" icon="ios-add-circle-outline" @click="onModel2">添加点检表设备</Button>
        </div>
      </div>
      <Table border ref="selection" :columns="columns7" :data="data6" :loading="loading"></Table>
      <div class="role02">
        <Page :total="total" @on-change="nextPage"/>
      </div>

      <Modal
        v-model="modal1"
        title="添加编辑设备"
        :mask-closable="false"
        @on-ok="add"
        @on-cancel="bigON">
        <Input v-model="name" placeholder="请输入设备名称">
          <span slot="prepend">名称</span>
        </Input>
        <Input v-model="xingh" placeholder="请输入设备型号" class="mod02">
          <span slot="prepend">型号</span>
        </Input>
        <Input v-model="brand" placeholder="请输入设备品牌" class="mod02">
          <span slot="prepend">品牌</span>
        </Input>
        <Input v-model="bianh" placeholder="请输入设备编号" class="mod02">
          <span slot="prepend">设备编号</span>
        </Input>
        <Input v-model="synx" placeholder="请输入使用年限" class="mod02">
          <span slot="prepend">使用年限</span>
        </Input>
        <Input v-model="cjphone" placeholder="请输入厂家联系方式" class="mod02">
          <span slot="prepend">厂家联系方式</span>
        </Input>
        <el-select
          v-model="keyword"
          multiple
          filterable
          remote
          reserve-keyword
          :multiple-limit="1"
          class="mo05"
          placeholder="【生产人员】请输入关键词搜索员工"
          :remote-method="remoteMethod"
          @change="pd_sbModel"
          :loading="loadings">
          <el-option
            v-for="item in list"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
<!--        <el-select-->
<!--          v-model="keywords"-->
<!--          multiple-->
<!--          filterable-->
<!--          remote-->
<!--          reserve-keyword-->
<!--          :multiple-limit="1"-->
<!--          class="mo05"-->
<!--          placeholder="【故障负责人】请输入关键词搜索员工"-->
<!--          :remote-method="remoteMethods"-->
<!--          @change="pd_sbModel1"-->
<!--          :loading="loadings">-->
<!--          <el-option-->
<!--            v-for="item in lists"-->
<!--            :key="item.value"-->
<!--            :label="item.label"-->
<!--            :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
        <div class="mo06">
          <div class="mo07">
            <el-date-picker
              v-model="ccDate"
              type="date"
              class="mo05"
              placeholder="【出厂日期】请选择出厂日期">
            </el-date-picker>
          </div>
          <div class="mo07">
            <el-select v-model="jiagou" placeholder="请选择组织架构" style="width: 100%" class="mo05">
              <el-option v-for="(item,index) in jiagouArr" :label="item.name" :key="index" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
      </Modal>

      <Modal
        v-model="modal2"
        title="添加编辑设备"
        :mask-closable="false"
        @on-ok="add_djb"
        @on-cancel="bigON_djb">
        <Input v-model="djb_no" placeholder="请输入点检表编号">
          <span slot="prepend">编号</span>
        </Input>
        <Input v-model="name_djb" placeholder="请输入设备名称" class="mod02">
          <span slot="prepend">名称</span>
        </Input>
        <Input v-model="xingh_djb" placeholder="请输入设备型号" class="mod02">
          <span slot="prepend">型号</span>
        </Input>
        <Input v-model="brand_djb" placeholder="请输入设备品牌" class="mod02">
          <span slot="prepend">品牌</span>
        </Input>
        <Input v-model="bianh_djb" placeholder="请输入设备编号" class="mod02">
          <span slot="prepend">设备编号</span>
        </Input>
        <Input v-model="synx_djb" placeholder="请输入使用年限" class="mod02">
          <span slot="prepend">使用年限</span>
        </Input>
        <Input v-model="cjphone_djb" placeholder="请输入厂家联系方式" class="mod02">
          <span slot="prepend">厂家联系方式</span>
        </Input>
        <el-select
          v-model="keyword_djb"
          multiple
          filterable
          remote
          reserve-keyword
          :multiple-limit="1"
          class="mo05"
          placeholder="【生产人员】请输入关键词搜索员工"
          :remote-method="remoteMethod_djb"
          :loading="loadings_djb">
          <el-option
            v-for="item in list_djb"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
<!--        <el-select-->
<!--          v-model="keywords_djb"-->
<!--          multiple-->
<!--          filterable-->
<!--          remote-->
<!--          reserve-keyword-->
<!--          :multiple-limit="1"-->
<!--          class="mo05"-->
<!--          placeholder="【故障负责人】请输入关键词搜索员工"-->
<!--          :remote-method="remoteMethods_djb"-->
<!--          :loading="loadings_djb">-->
<!--          <el-option-->
<!--            v-for="item in lists_djb"-->
<!--            :key="item.value"-->
<!--            :label="item.label"-->
<!--            :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
        <div class="mo06">
          <div class="mo07">
            <el-date-picker
              v-model="gmDate_djb"
              type="date"
              class="mo05"
              placeholder="【出厂日期】请选择出厂日期">
            </el-date-picker>
          </div>
          <div class="mo07">
            <el-select v-model="jiagou" placeholder="请选择组织架构" style="width: 100%" class="mo05">
              <el-option v-for="(item,index) in jiagouArr" :label="item.name" :key="index" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
      </Modal>
    </van-skeleton>
  </div>
</template>

<script>
  import httpDev from '@/api/device';
  import util from "../../util/util";
  export default {
    name: "list",
    data(){
      return {
        columns7: [
          {
            title: '名称',
            key: 'name',
            render: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'person'
                  }
                }),
                h('strong', params.row.name)
              ]);
            }
          },
          {
            title: '品牌',
            key: 'brand'
          },
          {
            title: '编号',
            key: 'deviceNo'
          },
          {
            title: '状态',
            key: 'zhut'
          },
          {
            title: '组织架构',
            key: 'orgName'
          },
          {
            title: '出厂日期',
            key: 'buyTime'
          },
          {
            title: '上次维修日期',
            key: 'lastbytime'
          },
          {
            title: '操作',
            key: 'action',
            width: 170,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    icon:'md-pie'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.Details(params.index)
                    }
                  }
                }, '详情'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small',
                    icon:'ios-create-outline'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, '编辑'),
              ]);
            }
          }
        ],
        data6: [],
        loading_ske:true,     //骨架屏显示
        loading:false,        //是否加载
        modal1:false,         //是否显示选择模块
        modal2:false,         //是否显示点检表设备模块
        xzid:'',              //选中的ID
        id:'',                //选择时的ID
        page:1,               //当前页
        pageSize:10,          //显示条数
        total:0,              //列表总数
        is_edit:false,        //是否为编辑模式
        sbid:'',              //当前设备ID
        name:'',              //设备名称
        xingh:'',             //设备型号
        gzAdmin:'',           //故障负责人
        bianh:'',             //编号
        gmDate:'',            //购买时间
        sbAdmin:'',           //设备管理员
        byDate:'',            //保养时间
        brand:'',             //品牌
        loadings:'',          //搜索框
        list: [],             //保存搜索出设备负责人的数组
        keyword:[],           //设备管理员搜索关键词
        keywords:[],          //故障负责人搜索关键词
        lists:[],             //保存搜索出故障负责人的数组

        djb_no:'',                //点检表编号
        name_djb:'',              //设备名称
        xingh_djb:'',             //设备型号
        gzAdmin_djb:'',           //故障负责人
        bianh_djb:'',             //编号
        gmDate_djb:'',            //购买时间
        sbAdmin_djb:'',           //设备管理员
        byDate_djb:'',            //保养时间
        brand_djb:'',             //品牌
        loadings_djb:'',          //搜索框
        list_djb: [],             //保存搜索出设备负责人的数组
        keyword_djb:[],           //设备管理员搜索关键词
        keywords_djb:[],          //故障负责人搜索关键词
        lists_djb:[],             //保存搜索出故障负责人的数组
        jiagouArr:[],             //组织架构数组
        jiagou:'',                //架构
        ccDate:'',                //出厂日期

        synx:'',                  //使用年限
        cjphone:'',               //厂家联系方式
        synx_djb:'',              //使用年限
        cjphone_djb:'',           //出厂日期

      }
    },
    created() {
    },
    mounted() {
      var me = this;
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = {
        mobile:user.mobile,
        sign:user.sign,
        userId:user.userId,
        companyId:user.companyId,
        pageSize:me.pageSize,
        page:me.page
      }
      if (user.companyId == 1) {
        data['companyId'] = ''
      }
      console.log(user);
      let datas = {
        mobile:user.mobile,
        sign:user.sign,
        companyId:user.companyId,
        pid:'-1',
        type:2
      }
      Promise.all([
        httpDev.devicelist(data),
        httpDev.orgList(datas),
      ]).then((values) => {
        console.log(values);
        me.data6 = values[0].data.dataList;
        me.total = values[0].data.totalNum;
        me.data6.forEach(function (item,index) {
          switch (item.state) {
            case 0:
              me.$set(item,'zhut','维修中');
              break;
            case 1:
              me.$set(item,'zhut','保修中');
              break;
            case 2:
              me.$set(item,'zhut','正常');
              break;
            case 4:
              me.$set(item,'zhut','已废弃');
              break;
          }
        })
        me.jiagouArr = values[1].data;
        me.loading_ske = false;
      })
    },
    methods:{
      toGzDc(){//跳转导出故障率页面
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'设备管理','导出设备故障单');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$router.push({name:'gzExport',params:{}})
      },
      exportDc(){//跳往维修单导出页面
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'设备管理','导出维修单');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$router.push({name:'wxExport',params:{}})
      },
      nextPage(e){//下一页
        var me = this;
        me.loading = true;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          mobile:user.mobile,
          sign:user.sign,
          userId:user.userId,
          companyId:user.companyId,
          pageSize:me.pageSize,
          page:e
        }
        me.page = e;
        if (user.companyId == 1) {
          data['companyId'] = ''
        }
        httpDev.devicelist(data).then(res => {
          me.data6 = res.data.dataList;
          me.data6.forEach(function (item,index) {
            switch (item.state) {
              case 0:
                me.$set(item,'zhut','维修中');
                break;
              case 1:
                me.$set(item,'zhut','保修中');
                break;
              case 2:
                me.$set(item,'zhut','正常');
                break;
              case 4:
                me.$set(item,'zhut','已废弃');
                break;
            }
          })
          me.loading = false;
        })
      },
      Details(index){//查看详情
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'设备管理','设备详情');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$router.push({name:'devDetail',params:{sbid:me.data6[index].id}})
      },
      edit(index){//编辑
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'设备管理','编辑设备');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.is_edit = true;
        console.log(me.data6[index]);
        let item = me.data6[index];
        me.sbid = item.id;
        me.name = item.name;
        me.xingh = item.model;
        me.brand = item.brand;
        me.bianh = item.deviceNo;
        me.synx = item.lifeage;
        me.cjphone = item.factorycontact;
        if (item.buyTime != null && item.buyTime != '') {
          let reg=new RegExp('/','g')//g代表全部
          item.buyTime = item.buyTime.replace(reg,'-');
          me.ccDate = item.buyTime;
        }
        // me.jiagou = item.orgName;
        me.keyword = [];
        // me.keywords = [];
        me.keyword.push(item.produceuserid);
        let li = {value: `${item.produceuserid}`, label: `${item.produceuserName}`}
        me.list.push(li);
        // me.keywords.push(item.breakdownUserId);
        // let lis = {value: `${item.breakdownUserId}`, label: `${item.weixiuName}`}
        // me.lists.push(lis);
        me.modal1 = true;
      },
      onModel1(){//打开模态框
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'设备管理','添加设备');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.is_edit = false;
        me.modal1 = true;
      },
      onModel2(){//打开添加点检表模态框
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'设备管理','添加设备');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.modal2 = true;
      },
      bigON(){//关闭模态框
        var me = this;
        me.name = '';
        me.xingh = '';
        me.gzAdmin = '';
        me.bianh = '';
        me.gmDate = '';
        me.sbAdmin = '';
        me.byDate = '';
        me.brand = '';
        me.keyword = [];
        me.keywords = [];
        me.list = [];
        me.lists = [];
        me.jiagou = '';
        me.ccDate = '';
        me.modal1 = false;
        me.synx = '';
        me.cjphone = '';
      },
      bigON_djb(){//关闭点检表模态框
        var me = this;
        me.djb_no = '';
        me.name_djb = '';
        me.xingh_djb = '';
        me.gzAdmin_djb = '';
        me.bianh_djb = '';
        me.gmDate_djb = '';
        me.sbAdmin_djb = '';
        me.byDate_djb = '';
        me.brand_djb = '';
        me.keyword_djb = [];
        me.keywords_djb = [];
        me.list_djb = [];
        me.lists_djb = [];
        me.jiagou = '';
        me.ccDate = '';
        me.modal2 = false;
        me.synx = '';
        me.cjphone = '';
        me.synx_djb = '';
        me.cjphone_djb = '';
      },
      remoteMethod(query) {//搜索设备负责人
        var me = this;
        if (query !== '') {
          me.loadings = true;
          setTimeout(() => {
            let user = JSON.parse(sessionStorage.getItem('user'));
            let data = {
              userName:query,
              mobile:user.mobile,
              sign:user.sign,
              companyId:user.companyId,
              pageSize:5000,
              page:1
            }
            httpDev.userlist(data).then(res => {
              me.list = res.data.dataList.map(item => {
                return { value: `${item.id}`, label: `${item.name}` };
              });
              // me.userLists = me.list.filter(item => {
              //   return item.label.toLowerCase()
              //     .indexOf(query.toLowerCase()) > -1;
              // });
              console.log(me.list);
              me.loadings = false;
            })
          }, 200);
        } else {
          me.list = [];
        }
      },
      remoteMethod_djb(query) {//搜索设备负责人
        var me = this;
        if (query !== '') {
          me.loadings_djb = true;
          setTimeout(() => {
            let user = JSON.parse(sessionStorage.getItem('user'));
            let data = {
              userName:query,
              mobile:user.mobile,
              sign:user.sign,
              companyId:user.companyId,
              pageSize:5000,
              page:1
            }
            httpDev.userlist(data).then(res => {
              me.list_djb = res.data.dataList.map(item => {
                return { value: `${item.id}`, label: `${item.name}` };
              });
              // me.userLists = me.list.filter(item => {
              //   return item.label.toLowerCase()
              //     .indexOf(query.toLowerCase()) > -1;
              // });
              me.loadings_djb = false;
            })
          }, 200);
        } else {
          me.list_djb = [];
        }
      },
      remoteMethods(query){//搜索故障负责人
        var me = this;
        if (query !== '') {
          me.loadings = true;
          setTimeout(() => {
            let user = JSON.parse(sessionStorage.getItem('user'));
            let data = {
              userName:query,
              mobile:user.mobile,
              sign:user.sign,
              companyId:user.companyId,
              pageSize:5000,
              page:1
            }
            httpDev.userlist(data).then(res => {
              me.lists = res.data.dataList.map(item => {
                return { value: `${item.id}`, label: `${item.name}` };
              });
              console.log(me.list);
              me.loadings = false;
            })
          }, 200);
        } else {
          me.lists = [];
        }
      },
      remoteMethods_djb(query){//搜索故障负责人
        var me = this;
        if (query !== '') {
          me.loadings_djb = true;
          setTimeout(() => {
            let user = JSON.parse(sessionStorage.getItem('user'));
            let data = {
              userName:query,
              mobile:user.mobile,
              sign:user.sign,
              companyId:user.companyId,
              pageSize:5000,
              page:1
            }
            httpDev.userlist(data).then(res => {
              me.lists_djb = res.data.dataList.map(item => {
                return { value: `${item.id}`, label: `${item.name}` };
              });
              console.log(me.list);
              me.loadings_djb = false;
            })
          }, 200);
        } else {
          me.lists_djb = [];
        }
      },
      add(){//添加
        var me = this;
        me.$Loading.start();
        if (me.name == '') {
          me.$message.error('请输入设备名称');
          me.$Loading.error();
          return false;
        }
        if (me.xingh == '') {
          me.$message.error('请输入型号');
          me.$Loading.error();
          return false;
        }
        if (me.brand == '') {
          me.brand = '暂未填写';
        }
        if (me.bianh == '') {
          me.bianh = '暂未填写';
        }
        // if (me.keyword.length < 1) {
        //   me.$message.error('请选择设备管理员');
        //   me.$Loading.error();
        //   return false;
        // }
        // if (me.keywords.length < 1) {
        //   me.$message.error('请选择故障负责人');
        //   me.$Loading.error();
        //   return false;
        // }
        // if (me.keyword[0] == me.keywords[0]) {
        //   me.$message.error('设备管理员与故障负责人不能为同一人');
        //   me.$Loading.error();
        //   return false;
        // }
        // if (me.gmDate == '') {
        //   me.$message.error('请选择购买日期');
        //   me.$Loading.error();
        //   return false;
        // }
        // if (me.byDate == '') {
        //   me.$message.error('请选择保养日期');
        //   me.$Loading.error();
        //   return false;
        // }
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          name:me.name,
          model:me.xingh,
          breakdownUserId:'',
          deviceNo:me.bianh,
          buyTime:me.ccDate,
          keepTime:'',
          companyId:user.companyId,
          sign:user.sign,
          mobile:user.mobile,
          state:2,
          adminUserId:'',
          brand:me.brand,
          exfactorydata:'',
          orgId:me.jiagou,
          lifeage:me.synx,
          factorycontact:me.cjphone,
          produceuserid:me.keyword[0]
        }
        if (me.sbid != '') {
          data['id'] = me.sbid;
          data['state'] = '';
        }
        httpDev.addorupdatedevice(data).then(res => {
          switch (res.code) {
            case '0000':
              let datas = {
                mobile:user.mobile,
                sign:user.sign,
                userId:user.userId,
                companyId:user.companyId,
                pageSize:me.pageSize,
                page:me.page
              }
              httpDev.devicelist(datas).then(res => {
                me.data6 = res.data.dataList;
                me.data6.forEach(function (item,index) {
                  switch (item.state) {
                    case 0:
                      me.$set(item,'zhut','维修中');
                      break;
                    case 1:
                      me.$set(item,'zhut','保修中');
                      break;
                    case 2:
                      me.$set(item,'zhut','正常');
                      break;
                    case 4:
                      me.$set(item,'zhut','已废弃');
                      break;
                  }
                })
              })
              me.name = '';
              me.xingh = '';
              me.bianh = '';
              me.ccDate = '';
              me.brand = '';
              me.keyword = [];
              me.keywords = [];
              me.list = [];
              me.lists = [];
              me.jiagou = '';
              me.synx = '';
              me.cjphone = '';
              if (me.sbid != '') {
                me.$message.success('编辑成功');
              } else {
                me.$message.success('添加成功');
              }
              me.sbid = '';
              me.$Loading.finish();
              break;
            case '1111':
              me.$message.error('编辑失败');
              me.$Loading.error();
              break;
            case '1100':
              me.$message.error('设备管理人员不能为采购');
              me.$Loading.error();
              break;
            case '1101':
              me.$message.error('设备维修人员不能是采购');
              me.$Loading.error();
              break;
            case "1115":
              me.$message.error('设备管理人员无系统角色');
              me.$Loading.error();
              break;
            case "1116":
              me.$message.error('设备维修人员无系统角色');
              me.$Loading.error();
              break;
          }
        })
      },
      add_djb(){//添加点检表设备
        var me = this;
        me.$Loading.start();
        if (me.djb_no == '') {
          me.$message.error('请输入点检表编号');
          me.$Loading.error();
          return false;
        }
        if (util.is_num(me.djb_no) == false) {
          me.$message.error('编号为全数字');
          me.$Loading.error();
          return false;
        }
        if (me.name_djb == '') {
          me.$message.error('请输入设备名称');
          me.$Loading.error();
          return false;
        }
        if (me.xingh_djb == '') {
          me.$message.error('请输入型号');
          me.$Loading.error();
          return false;
        }
        if (me.brand_djb == '') {
          me.brand_djb = '暂未填写';
        }
        if (me.bianh_djb == '') {
          me.bianh_djb = '暂未填写';
        }
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          codeImgNo:me.djb_no,
          name:me.name_djb,
          model:me.xingh_djb,
          breakdownUserId:'',
          deviceNo:me.bianh_djb,
          buyTime:me.gmDate_djb,
          keepTime:'',
          companyId:user.companyId,
          sign:user.sign,
          mobile:user.mobile,
          state:2,
          adminUserId:'',
          brand:me.brand_djb,
          exfactorydata:'',
          orgId:me.jiagou,
          lifeage:me.synx_djb,
          factorycontact:me.cjphone_djb,
          produceuserid:me.keyword_djb[0]
        }
        httpDev.addorupdatedevice(data).then(res => {
          switch (res.code) {
            case '0000':
              let datas = {
                mobile:user.mobile,
                sign:user.sign,
                userId:user.userId,
                companyId:user.companyId,
                pageSize:me.pageSize,
                page:me.page
              }
              httpDev.devicelist(datas).then(res => {
                me.data6 = res.data.dataList;
                me.data6.forEach(function (item,index) {
                  switch (item.state) {
                    case 0:
                      me.$set(item,'zhut','维修中');
                      break;
                    case 1:
                      me.$set(item,'zhut','保修中');
                      break;
                    case 2:
                      me.$set(item,'zhut','正常');
                      break;
                    case 4:
                      me.$set(item,'zhut','已废弃');
                      break;
                  }
                })
              })
              me.$message.success('添加成功');
              me.$Loading.finish();
              break;
            case '1111':
              me.$message.error('编辑失败');
              me.$Loading.error();
              break;
            case '1100':
              me.$message.error('设备管理人员不能为采购');
              me.$Loading.error();
              break;
            case '1101':
              me.$message.error('设备维修人员不能是采购');
              me.$Loading.error();
              break;
            case "1115":
              me.$message.error('设备管理人员无系统角色');
              me.$Loading.error();
              break;
            case "1116":
              me.$message.error('设备维修人员无系统角色');
              me.$Loading.error();
              break;
            case '1117':
              me.$message.error('点检表编号不存在');
              me.$Loading.error();
              break;
            case '1118':
              me.$message.error('点检表编号未绑定或者不属于该公司');
              me.$Loading.error();
              break;
          }
          me.djb_no = '';
          me.name_djb = '';
          me.xingh_djb = '';
          me.bianh_djb = '';
          me.brand_djb = '';
          me.gmDate_djb = '';
          me.jiagou = '';
          me.keyword_djb = [];
          me.keywords_djb = [];
          me.list_djb = [];
          me.lists_djb = [];
          me.cjphone_djb = '';
          me.synx_djb = '';
        })
      },
      pd_sbModel(){//选择设备管理员时数据的变化处理
        var me = this;
        console.log(me.keyword);
        console.log(me.list);
      },
      pd_sbModel1(){//选择故障负责人时数据的变化处理
        var me = this;
        console.log(me.keywords);
      }
    }
  }
</script>

<style scoped>
@import "device.css";
</style>